module.exports = __webpack_public_path__ + "static/media/3.ce5ac515.svg";